/**
 * @prettier
 */
export function transformIntInput(value?: string | null): string {
    return value?.toString() ?? '';
}
